// The one 'Sign in' control, and the page a signed-out app shows on every route (E12-S1-T2).
//
// Signing in is the API's (E15-S4): the control is a plain link, so the browser makes a top-level
// navigation to GET /auth/login with the return path, the API sends it on to the identity provider,
// and the provider's callback sets the httpOnly session cookie and comes back. Nothing is fetched
// here and nothing is stored. The return path is checked before the navigation (return-path.ts).
//
// No mockup draws a signed-out screen; this one is the hub's page as the frame draws every other —
// the heading, then one panel in the kit's panel chrome (mockups/kit/surface.css "Panels") with the
// lock glyph, a line and the primary button. Every word is the catalogue's.
import { Button, Card, Icon } from "@waypoint/surface";
import { t } from "../i18n/t.js";
import { Page } from "../pages/page.js";
import { signInHref } from "./return-path.js";

export function SignInControl({ returnTo }: { returnTo: string }) {
  return (
    <Button asChild variant="primary">
      <a href={signInHref(returnTo)}>{t("session.signIn")}</a>
    </Button>
  );
}

/**
 * Signed out: the heading and the sign-in control, and nothing else from the hub. `ended` is the
 * page sign-out lands on (/signed-out); otherwise the session ended elsewhere, or never began.
 */
export function SignedOutPage({ returnTo, ended = false }: { returnTo: string; ended?: boolean }) {
  return (
    <Page title={t(ended ? "session.ended.title" : "session.signedOut.title")}>
      <Card className="grid max-w-lg justify-items-start gap-3 p-5">
        <span className="grid size-9 place-items-center rounded-8 bg-br-sky/9 text-wp-accent">
          <Icon name="lock" size={18} />
        </span>
        <div className="grid gap-1">
          <p className="text-15 font-semibold text-wp-text">
            {t(ended ? "session.ended.line" : "session.signedOut.line")}
          </p>
          <p className="text-13 text-wp-text-3">{t("session.signIn.line")}</p>
        </div>
        <SignInControl returnTo={returnTo} />
      </Card>
    </Page>
  );
}
